export default __webpack_public_path__ + "static/media/43_2_2.d6aacd42.png";